import React, { Component } from "react"
import { connect } from "react-redux"
import { setLevel, setModal, showModal, undo } from "actions"

import ProtocolRead from "components/modal/modals/protocolRead/ProtocolRead"
import Undo from "components/modal/modals/undo/Undo"
import EndSimulation from "components/modal/modals/endSimulation/EndSimulation"
import {LevelSelector} from "@learningblocks/storybook-components/lib/LevelSelector_new"

import { withTranslation } from 'react-i18next'

import "./Modal.scss";

import {Modal as ModalWrapper} from '@learningblocks/shared-components/lib/Modal';
import style from './style.module.scss';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getContent = type => {
    switch (type) {
      case "PROTOCOL_READ":
        return <ProtocolRead />;

      case "LEVEL_CHOICE":
        return (
          <div className="modal-section level-choice">
            <LevelSelector simulationLevels={[
              {
                id: 1,
                value: 'levelOne',
              },
              {
                id: 2,
                value: 'levelTwo',
              },
              {
                id: 3,
                value: 'levelThree',
              },
            ]}
            levelNames={["One", "Two", "Three"]}
            defaultSelected={1}
            setLevel={(level) => {
              this.props.setLevel({level: level.id})
              this.props.showModal(false)
            }} />
          </div>);

      case "UNDO":
        return <Undo />

      case "END_SIMULATION":
        return <EndSimulation />;

      default:
        return "No modal type matched";
    }
  };

  close = () => {
    this.props.showModal({ display: false });
  };

  render() {
    return (
      <ModalWrapper
        className={style.protocol_modal}
        closeButton={(this.props.type !== "LEVEL_CHOICE")?true:false}
        close={this.close}
        isOpen={this.props.display}
        notebookExpanded={
          (this.props.type !== "LEVEL_CHOICE")?this.props.notebookExpanded:false
        }
        hideBackground={(this.props.type === "LEVEL_CHOICE")}
        fullScreen={(
          this.props.type === "LEVEL_CHOICE" ||
          this.props.type === "END_SIMULATION"
        )}
        lang={this.props.lang}
        parentElement={'container'}
      >
          <div
            className={"Modal " + this.props.size}
          >
            <div
              style={{height: "100%"}}
            >
              <div className="wrapper">
                {this.getContent(this.props.type)}
              </div>
            </div>
          </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    display: state.modal.display,
    type: state.modal.type,
    size: state.modal.size,
    connect: state.modal.connect,
    pipetteId: state.modal.pipetteId,
    gelId: state.modal.gelId,
    gelBoxId: state.modal.gelBoxId,

    lang: state.scene.lang,
    notebookExpanded: state.scene.notebookExpanded
  };
};

export default connect(
  mapStateToProps,
  {
    setLevel,
    setModal,
    showModal,
    undo
  }
)(withTranslation()(Modal));
